import { RMAItemShipment } from "./RMAItemShipment";
import { RMAResponse } from "./RMAResponse";

export class RMAItem {
  constructor() {
    this.Followed = false;
    this.Shipments = [];
  }

  public RMANumber: string;
  public RMALine: number;
  public RMAStatus: string;
  public Item: string;
  public Description: string;
  public Quantity: number;
  public Disp: string;
  public EvalCode: string;
  public EvalDesc: string;
  public QtyReceived: number;
  public LastReturnDate: string;  
  public RMAItemRowPointer: string;
  public Reason: string;
  public DispDate: string;
  public DispUser: string;
  public EvalDate: string;
  public EvalUser: string;
  public FailureCode: string;
  public ProductLine: string;
  public DispDesc: string;
  public RepairOrder: string;
  public RepairOrderLine: number;
  public QtyShipped: number;
  public ShipDate: string;
  public EstShipDate: string;
  public Response: RMAResponse;
  public RMAEvalPath: string;
  public OrderNumber: string;
  public LineNumber: number;
  public CreateDate: Date;

  public Followed: boolean;

  public ShortReason: string;
  public ShortDesc: string;

  public Shipments: RMAItemShipment[];
}

